import { useMemo } from 'react'
import type { JTLDescription } from '@/lib/api/descriptions'
import {
  CONTENT_FIELDS,
  type ContentFieldKey,
  getFieldValue,
} from '@/components/products/v2/tabs/content/channels/channel-constants'

export type InheritanceStatus = 'inherited' | 'overridden'
export type InheritanceMap = Record<ContentFieldKey, InheritanceStatus>

export function computeInheritanceMap(
  master: JTLDescription | undefined,
  channel: JTLDescription | undefined,
): InheritanceMap {
  const map = {} as InheritanceMap
  for (const field of CONTENT_FIELDS) {
    const mv = getFieldValue(master, field)
    const cv = getFieldValue(channel, field)
    map[field] = cv !== '' && cv !== mv ? 'overridden' : 'inherited'
  }
  return map
}

export function countOverrides(map: InheritanceMap): number {
  return Object.values(map).filter((s) => s === 'overridden').length
}

export function useInheritance(
  master: JTLDescription | undefined,
  channel: JTLDescription | undefined,
) {
  return useMemo(() => {
    const map = computeInheritanceMap(master, channel)
    return { map, overrideCount: countOverrides(map) }
  }, [master, channel])
}
